/**
 * What an admin action says when it ends (ADM-13). In production no dev token comes back, so
 * issuing a sign-up link (create, activate, reissue) showed nothing at all, and several actions
 * dropped the server's refusals (e.g. LOGIN_DISABLED) without a word.
 */

import { toast } from "sonner";

import type { SignupLink } from "../api/admin";
import { describeError } from "../api/errors";

/** "Sign-up link sent; it expires 19 Oct, 4:30 pm." */
export function signupLinkSent(link: Pick<SignupLink, "expires_at">, lead = "Sign-up link sent"): string {
  const expires = new Date(link.expires_at).toLocaleString(undefined, {
    day: "numeric",
    month: "short",
    hour: "numeric",
    minute: "2-digit",
  });
  return `${lead}; it expires ${expires}.`;
}

/** onError for an admin action: the server's reason as a toast. */
export const toastFailure = (e: unknown): void => {
  toast.error(describeError(e));
};
